/**
 * @ngdoc controller
 * @name GiftController
 * @description Gifting the e-course.
 * @constructor
 */
export default function GiftController($state, RegistrationService, User, ecourse, BraintreeForm, $rootScope, $scope, $timeout) {
  'ngInject';

  this.formData = RegistrationService.formData;

  this.ecourse = ecourse;

  this.countries = RegistrationService.countries;

  this.states = RegistrationService.states;

  this.state = $state;

  this.formData.gift = true;

  this.allowDiscount = false;

  this.planFree = RegistrationService.planFree;

  this.planPrice = RegistrationService.planPrice;

  this.generateScreenName = RegistrationService.generateScreenName;

  this.ccFormId = 'cc-input-form';

  this.selectPlan = plan => {
    this.formData.plan = plan;
    this.complete();
  };

  this.complete = () => {
    let go = true;
    if (!User.loggedIn()) {
      go = false;
      if (this.formData && this.userForm && this.userForm.$valid) {
        go = true;
      }
    }
    if (go) $state.go('app.ecourse.registration.gift.complete');
    else $state.go('app.ecourse.registration.gift.completeSignUp');
  };

  this.formValid = () => {
    //if the forms aren't there, then they are valid!
    let userValid = this.userForm ? this.userForm.$valid : true,
      paymentValid = this.cardForm && !this.planFree(this.allowDiscount) ? this.cardForm.$valid : true,
      giftForm = this.recipientForm.$valid;
    if (userValid && paymentValid && giftForm) {
      return true;
    }
    return false;
  };

  this.register = () => {
    if (this.formValid() && !this.loading) {
      let errors = (errors) => {
        //TODO - function to set validity of fields once on response.
        this.loading = false;
        if (errors.userForm) {
          $state.go('app.ecourse.registration.gift.completeSignUp');
        }
        if (errors.userCreated) {
          this.userCreated = true;
        }
        this.registrationErrors = errors;
      };
      if (!this.cardForm) {
        RegistrationService.register('purchase', ecourse, this).catch(errors);
      } else {
        $timeout(()=> {

          document.getElementById(`${this.ccFormId}-submit`).click();
          this.nonceEvent
            .subscribe((nonce)=> {
              this.formData.paymentMethodNonce = nonce;
              RegistrationService.register('gift', ecourse, this).catch(errors);
            });

          this.validationError
            .subscribe((error) => {
              $timeout(()=>{
                this.loading = false;
              });
            });
        });
      }
      this.loading = true;
    }
  };

  $rootScope.$on('$stateChangeSuccess', (event, toState) => {
    $timeout(()=> {
      if (toState.name.includes('complete') && this.cardForm) {
        const braintreeStream = BraintreeForm.initialize(this.ccFormId);
        braintreeStream.connect();
        braintreeStream
          .filter(({type})=> type === 'ready')
          .map(({payload})=> payload.teardown)
          .subscribe((t)=> {
            this.teardownPaymentSystem = t;
          });

        this.nonceEvent = braintreeStream
          .filter(({type})=> type === 'nonce')
          .map(({payload}) => payload.nonce);

        this.validationError = braintreeStream
          .filter(({type}) => type === 'validation_error')
          .map(({payload}) => payload);

        braintreeStream.subscribe((action)=> {
          console.log(action);
        });
      }
    });
  });


  $scope.$on("$destroy", () => {
    if (this.teardownPaymentSystem) {
      this.teardownPaymentSystem();
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/registration/gift/gift.controller.js
 **/